// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604300910/js/" + chunkId + "." + {"44":"9dfe302f","225":"5b51baf1","481":"4ec03f3e","486":"ec3c059c","770":"ca640c3f"}[chunkId] + ".0.20111276657357413.chunk.js";
};